import { render } from "./SuggestionsViewController.vue?vue&type=template&id=4d272b17&scoped=true"
import script from "./SuggestionsViewController.vue?vue&type=script&lang=js"
export * from "./SuggestionsViewController.vue?vue&type=script&lang=js"

import "./SuggestionsViewController.vue?vue&type=style&index=0&id=4d272b17&lang=scss"
import "./SuggestionsViewController.vue?vue&type=style&index=1&id=4d272b17&lang=scss"
import "./SuggestionsViewController.vue?vue&type=style&index=2&id=4d272b17&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d272b17"]])

export default __exports__